import { render, staticRenderFns } from "./MultiselectComponent.vue?vue&type=template&id=73568650&scoped=true&"
import script from "./MultiselectComponent.vue?vue&type=script&lang=js&"
export * from "./MultiselectComponent.vue?vue&type=script&lang=js&"
import style0 from "./MultiselectComponent.vue?vue&type=style&index=0&id=73568650&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73568650",
  null
  
)

export default component.exports